export function sortByCountDesc(a, b) {
  return b.count - a.count;
}

export function sortByName(a, b) {
  return a.value.localeCompare(b.value);
}

export function sortByRefined(fn) {
  return (a, b) => {
    if (a.refined !== b.refined) {
      if (a.refined) {
        return -1;
      }

      if (b.refined) {
        return 1;
      }
    }

    return fn(a, b);
  };
}
